import type { FaireProductEntity } from "../../entity_types/product";

export const p_gmrr38ewmf: FaireProductEntity = {
  token: "p_gmrr38ewmf",
  type: "product",
  name: "The Cr\u00e8me Shop Fusion Face Mask \u2013 Squalane & Rose Oil",
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/5ca31217a0ab696eb6e0519efd84478d4bec06865a75a1e6ccec38f158837f0c.jpeg",
  priceDollars: 0.55,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/95f56c794874baab13dc7a0b67bc8060fc2f358c475df45fc8f1e770e788a6a4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
